import {partition} from 'lodash';

const actualsColumnNames = ['actual-price', 'billable-time-entries', 'non-billable-time-entries'];

type AvailableColumn = {
	name: string;
	disabled: boolean;
	checked: boolean;
	translationId: string;
	nestedOptions?: AvailableColumn[];
};
export const groupEyeOptions = (availableColumns: AvailableColumn[]): AvailableColumn[] => {
	const [actualsOptions, restColumns] = partition(availableColumns, column => {
		return actualsColumnNames.includes(column.name);
	});

	const actualsOption = {
		name: 'actuals',
		disabled: false,
		checked: actualsOptions.some(option => option.checked),
		translationId: 'project_budget.actuals',
		nestedOptions: actualsOptions,
	};

	return actualsOptions && actualsOptions.length > 0 ? [actualsOption, ...restColumns] : restColumns;
};

const getColumnNameWithEyeOptionPrefix = (column: AvailableColumn): string => {
	if (actualsColumnNames.includes(column.name)) {
		return `actuals.${column.name}`;
	}

	return column.name;
};

type EyeOption = {
	[key: string]: boolean;
};
export const eyeOptionsToCols = (eyeOptions: EyeOption, availableColumns: AvailableColumn[]): AvailableColumn[] => {
	return availableColumns.map(column => {
		return {
			...column,
			checked: eyeOptions[getColumnNameWithEyeOptionPrefix(column)],
		};
	});
};
